import { Row } from '@tanstack/react-table';
import { OneWayInOpportunitySimpleV2Dto, OneWayInStatus } from 'src/api/v2';

export const statusSortValue: Record<OneWayInStatus, number> = {
  // archived
  [OneWayInStatus.AutoArchived]: 0,
  [OneWayInStatus.Closed]: 1,
  [OneWayInStatus.Forwarded]: 2,
  // onhold
  [OneWayInStatus.FollowUpLater]: 3,
  // wip
  [OneWayInStatus.EmailReceivedFromCustomer]: 4,
  [OneWayInStatus.EmailSentToCustomer]: 5,
  [OneWayInStatus.ReOpened]: 6,
  [OneWayInStatus.Shared]: 7,
  [OneWayInStatus.Active]: 8,
  // opened
  [OneWayInStatus.Opened]: 9,
  // new
  [OneWayInStatus.ReferredLater]: 10,
  [OneWayInStatus.Received]: 11,
  [OneWayInStatus.New]: 12,
};

export const statusSort = (a: OneWayInStatus | undefined, b: OneWayInStatus | undefined, desc = false) => {
  const undefinedValue = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
  const aValue = a != null ? statusSortValue[a] : undefinedValue;
  const bValue = b != null ? statusSortValue[b] : undefinedValue;
  return desc ? bValue - aValue : aValue - bValue;
};

export const statusSortTableRow = (
  rowA: Row<OneWayInOpportunitySimpleV2Dto>,
  rowB: Row<OneWayInOpportunitySimpleV2Dto>,
) => statusSort(rowA.original.status?.status, rowB.original.status?.status);
